import ChekSelector from './ChekSelector';
export default ChekSelector;
